import {useEffect} from "react";

import {useNavigateWithQuery, useNavigationPending} from "../hooks/navigationHooks";
import {selectInitialized as selectAddressInitialized, selectAddressSelected} from "../redux/addressSlice";
import {selectDevelopMode} from "../redux/envSlice";
import {selectPersistenceInitialized, selectPersistenceLoading, selectRevaId} from "../redux/persistenceSlice";
import {useRevaSelector} from "../redux/revaHooks";

export function useEffectRequiresValidRevaId(): void {
    const navigate = useNavigateWithQuery();
    const navigationPending = useNavigationPending();

    const isDevelop = useRevaSelector(selectDevelopMode);

    const persistenceInitialized = useRevaSelector(selectPersistenceInitialized);
    const persistenceLoading = useRevaSelector(selectPersistenceLoading);
    const revaId = useRevaSelector(selectRevaId);

    const addressSelected = useRevaSelector(selectAddressSelected);
    const addressInitialized = useRevaSelector(selectAddressInitialized);

    useEffect(() => {
        // Never overtake a navigation that is already under way: its target has not reached the
        // location yet, and a second navigate() would abort it.
        if (navigationPending()) {
            return;
        }
        if (persistenceInitialized && !persistenceLoading) {
            if (!revaId) {
                if (isDevelop) {
                    console.log("No valid RevaId loaded: redirect to start page");
                }
                navigate("/");
            } else if (addressInitialized && !addressSelected) {
                if (isDevelop) {
                    console.log("No valid address selected: redirect to start page");
                }
                navigate("/");
            }
        }
    }, [
        navigationPending,
        persistenceInitialized,
        persistenceLoading,
        revaId,
        addressInitialized,
        addressSelected,
        navigate,
        isDevelop,
    ]);
}
